export default function isVueComponent(component = {}) {
  return typeof component.render === 'function' || !!component.mixins
}
